import { Routes } from '@angular/router';
import { HomeComponent } from './routes/home/home.component';
import { TvComponent } from './routes/tv/tv.component';
import { DevComponent } from './routes/dev/dev.component';
import { SearchComponent } from './routes/search/search.component';
import { JamComponent } from './routes/jam/jam.component';
import { RegisterComponent } from './routes/register/register.component';
import { RemoteComponent } from './routes/remote/remote.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'tv', component: TvComponent },
  { path: 'dev', component: DevComponent },
  { path: 'search', component: SearchComponent },
  { path: 'jam', component: JamComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'godmode', component: RemoteComponent },
  { path: '**', redirectTo: '' },
];
